var map = {
	"./image-cards.de-CH.json": 1194,
	"./image-cards.de-DE.json": 1195,
	"./image-cards.en-CA.json": 1196,
	"./image-cards.en-GB.json": 1197,
	"./image-cards.en-IN.json": 1198,
	"./image-cards.en-ME.json": 1199,
	"./image-cards.en-US.json": 1200,
	"./image-cards.es-EM.json": 1201,
	"./image-cards.es-ES.json": 1202,
	"./image-cards.fr-BE.json": 1203,
	"./image-cards.fr-CA.json": 1204,
	"./image-cards.fr-CH.json": 1205,
	"./image-cards.nl-BE.json": 1206,
	"./image-cards.nl-NL.json": 1207,
	"./image-cards.pl-PL.json": 1208,
	"./image-cards.pt-BR.json": 1209
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1193;